@if (hasAnyContent) {
<div class="activity-card">
  <div class="section-label section-label--warning">Ça se passe au SDIS</div>
  <div class="dash-card dash-card--columns">
    @if (alarmsAvailable) {
    <div class="column">
      <div class="subsection-label">Alarmes</div>
      <app-last-msgr></app-last-msgr>
    </div>
    }
    @if (googleCalendarAvailable) {
    <div class="column">
      <div class="subsection-label">Officiers de service</div>
      <mir-google-calendars-widget></mir-google-calendars-widget>
    </div>
    }
  </div>
</div>
}
